(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    

(() => {
  const update = (track) => {
    const region = track.closest('.nmb-upsell');
    if (!region) return;
    const previous = region.querySelector('[data-nmb-slide="-1"]');
    const next = region.querySelector('[data-nmb-slide="1"]');
    if (previous) previous.disabled = track.scrollLeft <= 2;
    if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
  };
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-nmb-slide]');
    if (!button || !button.closest('#CartDrawer')) return;
    const track = button.closest('.nmb-upsell').querySelector('.cart-upsell');
    track.querySelectorAll('.nmb-upsell-options[open]').forEach(panel => { panel.open = false; });
    const item = track?.querySelector('.cart-upsell__item');
    if (!item) return;
    const step = item.getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap || 0);
    track.scrollBy({left: Number(button.dataset.nmbSlide) * step, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
  });
  document.addEventListener('scroll', (event) => {
    if (event.target instanceof Element && event.target.matches('#CartDrawer .cart-upsell')) update(event.target);
  }, true);
  document.addEventListener('focusin', (event) => {
    const region = event.target.closest?.('#CartDrawer .nmb-upsell');
    if (region) update(region.querySelector('.cart-upsell'));
  });
  document.addEventListener('toggle', (event) => {
    const panel = event.target;
    if (!(panel instanceof Element) || !panel.matches('#CartDrawer .nmb-upsell-options[open]')) return;
    panel.closest('.cart-upsell').querySelectorAll('.nmb-upsell-options[open]').forEach(other => {
      if (other !== panel) other.open = false;
    });
  }, true);
  window.addEventListener('resize', () => document.querySelectorAll('#CartDrawer .cart-upsell').forEach(update), {passive:true});
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template"]) return;
  try {
    
(() => {
  const observers = new WeakMap();
  const setup = (section) => {
    if (observers.has(section)) return;
    let trigger;
    const place = () => {
      const guide = section.querySelector('.nmb-sg');
      const original = guide && guide.querySelector('.sg-open');
      if (original) trigger = original;
      if (!guide || !trigger) return;
      const fields = section.querySelectorAll('.product-options .js-product-options fieldset');
      const field = Array.from(fields).find(el => {
        const input = el.querySelector('input[data-option]');
        return input && /size/i.test(input.dataset.option);
      });
      const label = field && field.querySelector('legend.product-options__option-label');
      if (!label || trigger.parentElement === label) return;
      label.classList.add('nmb-size-guide-label');
      trigger.classList.add('nmb-size-guide-trigger');
      label.appendChild(trigger);
      const source = guide.closest('.product-custom-liquid');
      if (source) source.classList.add('nmb-size-guide-source');
    };
    place();
    const observer = new MutationObserver(place);
    observer.observe(section, {childList:true,subtree:true});
    observers.set(section, observer);
  };
  const init = () => document.querySelectorAll('section.product[data-section-type="product"]').forEach(setup);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('section.product[data-section-type="product"]').forEach(section => {
      const observer = observers.get(section);
      if (observer) observer.disconnect();
      observers.delete(section);
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
